import useApiClient from './api';

const useModelService = () => {
  const apiClient = useApiClient();

  const getAvailableModels = async () => {
    try {
      const response = await apiClient.get('/models/available');
      return response.data;
    } catch (error) {
      console.error('Error fetching models from API:', error);
      // Return fallback hardcoded models
      return {
        success: false,
        fallback: true,
        data: {
          openai: [
            { value: 'gpt-4o', label: 'GPT-4o' },
            { value: 'gpt-4o-mini', label: 'GPT-4o Mini' },
            { value: 'gpt-4-turbo', label: 'GPT-4 Turbo' },
            { value: 'gpt-4', label: 'GPT-4' },
            { value: 'gpt-3.5-turbo', label: 'GPT-3.5 Turbo' }
          ],
          claude: [
            { value: 'claude-opus-4-5-20251101', label: 'Claude Opus 4.5 (Latest)' },
            { value: 'claude-sonnet-4-5-20250929', label: 'Claude Sonnet 4.5' },
            { value: 'claude-3-7-sonnet-20250219', label: 'Claude 3.7 Sonnet' },
            { value: 'claude-3-5-sonnet-20240620', label: 'Claude 3.5 Sonnet' },
            { value: 'claude-3-opus-20240229', label: 'Claude 3 Opus' },
            { value: 'claude-3-sonnet-20240229', label: 'Claude 3 Sonnet' },
            { value: 'claude-3-haiku-20240307', label: 'Claude 3 Haiku' }
          ]
        }
      };
    }
  };

  return { getAvailableModels };
};

export default useModelService;
